export default {"src":"/_next/static/media/full-yard.0c689ac6.svg","height":19,"width":19,"blurWidth":0,"blurHeight":0};